export var SERIAL_CRUD_ACTIONS = 'SERIAL_CRUD_ACTIONS';
export var SERIAL_CRUD_LOADING = 'SERIAL_CRUD_LOADING';
export var SERIAL_CRUD_SUCCESS = 'SERIAL_CRUD_SUCCESS';
export var SERIAL_CRUD_ERROR = 'SERIAL_CRUD_ERROR';
export var SERIAL_CRUD_BREAK = 'SERIAL_CRUD_BREAK';
export var SERIAL_CRUD_CONTINUE = 'SERIAL_CRUD_CONTINUE';
export var SERIAL_CRUD_ACTION = 'SERIAL_CRUD_ACTION';
export var serialActions = {
  serial: function serial(actions, throwError) {
    return {
      type: SERIAL_CRUD_ACTIONS,
      payload: {
        actions: actions,
        throwError: throwError
      }
    };
  },
  break: function _break() {
    return {
      type: SERIAL_CRUD_BREAK
    };
  },
  continue: function _continue() {
    return {
      type: SERIAL_CRUD_CONTINUE
    };
  }
};
//# sourceMappingURL=serial.js.map